import { render } from "./HeroiconsSolidSupport.vue?vue&type=template&id=47b12f92"
const script = {}

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSupport.vue"]])

export default __exports__